import { useEffect, useState } from 'react'
import { isHasTips } from 'lib/ie-version'
import { sendTeaCommEvent } from 'lib/tea-analyze'

// 是否需要添加顶部浏览器升级提示
function useHasTips() {
  const [value, setValue] = useState(false)

  useEffect(() => {
    const value = isHasTips()
    setValue(value)
  }, [])

  return value
}

export default useHasTips
